import React, { Component } from 'react';
import PropTypes from 'prop-types';
import delve from 'dlv';

import ConditionalWrapper from '../../ConditionalWrapper/ConditionalWrapper';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import YesNoUnknown from '../YesNoUnknown';
import isObjectNullOrEmpty from '../../../utils/isObjectNullOrEmpty';
import { PROPERTY_TYPES, SHORT_LINE_RAIL_OPTIONS } from '../../../constants';

export class PropertyDetailTransportationComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { showTransportationDetails: false };
  }
  componentWillReceiveProps(nextProps) {
    this.setStateFromProps(nextProps);
  }
  setStateFromProps(fromProps) {
    const { showDetailsTab } = fromProps;
    if (!showDetailsTab && this.state.showTransportationDetails) {
      // this.props.updateDetailsTab(this.state.showTransportationDetails);
      if (typeof this.props.updateDetailsTab === 'function') {
        this.props.updateDetailsTab(this.state.showTransportationDetails);
      }
    }
  }
  render() {
    const transportation = this.props.property.transportation;
    const viewer = this.props.viewer;
    const isBuilding = this.props.type === PROPERTY_TYPES.BUILDINGS;
    const detailSectionsToShow = isBuilding ? viewer.buildingSettings.detailSectionsToShow :
      viewer.siteSettings.detailSectionsToShow;

    const { shortLine } = transportation.rail;
    let hasShortLine = false;
    if (shortLine) {
      hasShortLine = !isObjectNullOrEmpty(shortLine, Object.keys(shortLine));
    }

    const railKeys = Object.keys(transportation.rail).filter(key => key !== 'shortLine');

    this.state.showTransportationDetails = ((
    !isObjectNullOrEmpty(transportation.highways, Object.keys(transportation.highways)) ||
    !isObjectNullOrEmpty(transportation.airports, Object.keys(transportation.airports)) ||
    !isObjectNullOrEmpty(transportation.massTransit, ['distanceToMassTransit']) ||
    !isObjectNullOrEmpty(transportation.rail, railKeys) ||
    hasShortLine)
    && (!detailSectionsToShow || detailSectionsToShow.includes('Transportation')));
    return (
      <div>
        <ConditionalWrapper
          condition={this.state.showTransportationDetails}
        >
          <section>
            <ViewerPrimaryColorUserStyle domStyle="color">
              <h4 className="section-title">Transportation</h4>
            </ViewerPrimaryColorUserStyle>
            <div className="section-body">
              <ul>
                {transportation.highways.nearestHighway &&
                <li>
                  <strong>Nearest Highway: </strong>
                  {transportation.highways.nearestHighway}
                  {
                    transportation.highways.nearestHighwayMiles > 0 &&
                    ` (${transportation.highways.nearestHighwayMiles} Miles)`
                  }
                </li>
                }
                {transportation.highways.nearestInterstate &&
                <li>
                  <strong>Nearest Interstate: </strong>
                  {transportation.highways.nearestInterstate}
                  {
                    transportation.highways.nearestInterstateMiles > 0 &&
                    ` (${transportation.highways.nearestInterstateMiles} Miles)`
                  }
                </li>
                }
                {transportation.airports.nearestGeneralAviationAirport &&
                <li>
                  <strong>Nearest Airport: </strong>
                  {transportation.airports.nearestGeneralAviationAirport}
                  {
                    transportation.airports.nearestGeneralAviationAirportMiles > 0 &&
                    ` (${transportation.airports.nearestGeneralAviationAirportMiles} Miles)`
                  }
                </li>
                }
                {transportation.airports.nearestCommercialAirport &&
                <li>
                  <strong>Nearest Commercial Airport: </strong>
                  {transportation.airports.nearestCommercialAirport}
                  {
                    transportation.airports.nearestCommercialAirportMiles > 0 &&
                    ` (${transportation.airports.nearestCommercialAirportMiles} Miles)`
                  }
                </li>
                }
                {transportation.massTransit.distanceToMassTransit > 0 &&
                <li>
                  <strong>Distance to Mass Transit: </strong>
                  {transportation.massTransit.distanceToMassTransit}
                </li>
                }
                {transportation.rail.railServed !== undefined &&
                transportation.rail.railServed !== null &&
                transportation.rail.railServed !== '' &&
                <li>
                  <strong>Rail Served: </strong>
                  <YesNoUnknown value={transportation.rail.railServed} />
                </li>
                }
                {transportation.rail.railServed !== 0 &&
                transportation.rail.railroadServicedBy &&
                transportation.rail.railroadServicedBy.length > 0 &&
                <li>
                  <strong>Rail Served By: </strong>
                  {transportation.rail.railroadServicedBy.join(', ')}
                </li>
                }
                {transportation.rail.railAccessible !== undefined &&
                transportation.rail.railAccessible !== null &&
                transportation.rail.railAccessible !== '' &&
                <li>
                  <strong>Rail Accessible: </strong>
                  <YesNoUnknown value={transportation.rail.railAccessible} />
                </li>
                }
                {transportation.rail.existingRailStructureInPlace !== undefined &&
                transportation.rail.existingRailStructureInPlace !== null &&
                transportation.rail.existingRailStructureInPlace !== '' &&
                <li>
                  <strong>Rail Infrastructure in Place: </strong>
                  <YesNoUnknown value={transportation.rail.existingRailStructureInPlace} />
                </li>
                }
                {transportation.railSupportLetterURL &&
                <li>
                  <strong>Rail Support Letter: </strong>
                  <a href={transportation.railSupportLetterURL}> Letter</a>
                </li>
                }
                {transportation.rail.contactName &&
                <li>
                  <strong>Rail Contact Name: </strong> {transportation.rail.contactName}
                </li>
                }
                {transportation.rail.contactPhone &&
                <li>
                  <strong>Rail Contact Phone: </strong> {transportation.rail.contactPhone}
                </li>
                }
                {transportation.rail.contactEmail &&
                <li>
                  <strong>Rail Contact Email: </strong> <a style={{ color: '#9f0000' }} href={`mailto:${transportation.rail.contactEmail}`}>{transportation.rail.contactEmail}</a>
                </li>
                }
                {delve(transportation, 'rail.shortLine.line') &&
                <li>
                  <strong>Short Line: </strong>
                  {SHORT_LINE_RAIL_OPTIONS[transportation.rail.shortLine.line]}
                </li>
                }
                {delve(transportation, 'rail.shortLine.contactName') &&
                <li>
                  <strong>Short Line Contact: </strong>
                  {transportation.rail.shortLine.contactName}
                </li>
                }
                {delve(transportation, 'rail.shortLine.contactPhone') &&
                <li>
                  <strong>Short Line Contact Phone: </strong>
                  {transportation.rail.shortLine.contactPhone}
                </li>
                }
                {delve(transportation, 'rail.shortLine.contactEmail') &&
                <li>
                  <strong>Short Line Contact Email: </strong>
                  <a style={{ color: '#9f0000' }} href={`mailto:${transportation.rail.shortLine.contactEmail}`}>{transportation.rail.shortLine.contactEmail}</a>
                </li>
                }
                {transportation.port.depthOfChannel > 0 &&
                <li>
                  <strong>Barge Access Depth of Channel: </strong>
                  {transportation.port.depthOfChannel}&quot;
                </li>
                }
                {transportation.port.craneCapacity > 0 &&
                <li>
                  <strong>Barge Crane Capacity: </strong>
                  {transportation.port.craneCapacity} T.
                </li>
                }
              </ul>
              {transportation.highways.describeIngress &&
              <div>
                <strong>Ingress/Egress Notes: </strong>
                {transportation.highways.describeIngress}
              </div>
              }
            </div>
          </section>
        </ConditionalWrapper>
      </div>
    );
  }
}

PropertyDetailTransportationComponent.propTypes = {
  type: PropTypes.string.isRequired,
  property: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
  updateDetailsTab: PropTypes.func,
};

export default PropertyDetailTransportationComponent;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailTransportation/PropertyDetailTransportation.js